module.exports = __webpack_public_path__ + "static/media/telephone-duotone.5f0b485a.svg";